import styled from 'styled-components';
import Button from '@material-ui/core/Button';

import DefaultMap from '../../../public/imgs/mapa-default.png';

export const ContainerMapaAnuncio = styled.div`
    width: 100%;
    height: 400px;
    margin-bottom: 40px;
`;

export const MapaPreview = styled.div`
    width: 100%;
    height: 100%;

    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;

    position: relative;

    overflow: hidden;

    -webkit-box-shadow: inset 0px 0px 7px 0px rgba(117, 117, 117, 1);
    -moz-box-shadow: inset 0px 0px 7px 0px rgba(117, 117, 117, 1);
    box-shadow: inset 0px 0px 7px 0px rgba(117, 117, 117, 1);

    &:before {
        content: '';
        width: 100%;
        height: 100%;

        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;

        background-image: url('${DefaultMap}');
        filter: blur(5px);
        -webkit-filter: blur(5px);
    }
`;

export const Titulo = styled.h2`
    font-size: 18px;
`;

export const MostrarMapaBtn = styled(Button)`
    && {
        width: 140px;
        height: 40px;
        border-radius: 2px;

        font-size: 14px;
        text-transform: none;
        color: #fff;
        font-weight: 500;
        background-color: #288394;

        .icon-map {
            margin-right: 5px;
        }

        &:hover {
            background: darken(#0495a8, 0.1);
        }
    }
`;

export const NotFoundAlert = styled.p`
    font-size: 27px;
    font-weight: bold;
    position: relative;
    text-align: center;
`;
